'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Copy = void 0;
const $ = require("jquery");
class Copy {
    constructor() {
        console.log('special');
        $(window).on('load scroll', () => {
            $('.paramSpecialArticle').each(function () {
                const scroll = $(window).scrollTop();
                const browserHeight = $(window).outerHeight();
                const position = $(this).offset().top;
                if (scroll > position - (browserHeight / 2)) {
                    $(this).find('.bulletSpecialArticleCopy p').attr('data-is-active', 'true');
                }
                else {
                    $(this).find('.bulletSpecialArticleCopy p').attr('data-is-active', 'false');
                }
            });
        });
    }
}
exports.Copy = Copy;
exports.default = Copy;
